import { SharedService } from 'src/app/services/shared.service';
import { CommandeService } from 'src/app/services/commande.service';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Subscription, timer, Observable } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrintService } from '../services/print.service';
import { UserService } from '../services/user.service';
import { AppSettings } from '../app.settings';
import { SnackBarService } from '../services/snack-bar.service';

@Component({
  selector: 'app-rejeter-dossier',
  templateUrl: './rejeter-dossier.component.html',
  styleUrls: ['./rejeter-dossier.component.scss']
})
export class RejeterDossierComponent implements OnInit {

  constructor( 
    private commandeService: CommandeService,

  private userService:UserService,
  public dialogRef: MatDialogRef<RejeterDossierComponent>,
 @Inject(MAT_DIALOG_DATA) public data: any,
  public sharedService: SharedService, 
  public print: PrintService, 
  private dialog: MatDialog,
  public appSettings:AppSettings,
  private _snackBar: SnackBarService) { }

  ngOnInit(): void {
    console.log("data",this.data.id);
    console.log("data commande",this.data.idCommande);

  }
  onClickYes(){
    this.commandeService.rejeterPackage(this.data.idCommande).subscribe(res => {
      this.dialogRef.close();
      this._snackBar.openSnackBar("Dossier annuler!!", "Fermer");
    });
  }

  onClickNo(){
    this.dialogRef.close();
  }


}
